import { combineReducers } from 'redux'
import { optionsIncomeAndExpenseReportCriteriaEditReducer } from './ReportCriteriaEdit'
import { optionsIncomeAndExpenseReportCriteriaPanelReducer } from './ReportCriteriaPanel'

export const optionsIncomeAndExpenseReportFeaturesReducer = combineReducers({
  reportCriteria: optionsIncomeAndExpenseReportCriteriaEditReducer,
  reportCriteriaPanel: optionsIncomeAndExpenseReportCriteriaPanelReducer
})
